import React from "react";
import Drawer from "@mui/material/Drawer";
import { Box, Typography } from "@mui/material";
import Btn from "../../common/Button/Button";
import Fi from "../Field/Fi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

export default function BottomModal({
  open,
  toggleDrawer,
  selectedMake,
  setSelectedMake,
}) {
  const [makeCount, setMakeCount] = React.useState(selectedMake.length);
  const [wordEntered, setWordEntered] = React.useState("");
  const [makeData, setMakeData] = React.useState({
    Caterpillar: false,
    Komatsu: false,
    XCMG: false,
    Sany: false,
    Volvo: false,
    "Hitachi Construction Machinery": false,
    "Liebherr Group": false,
  });

  const [filteredData, setFilteredData] = React.useState({ ...makeData });

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const keys = Object.keys(makeData);
    const newKeys = keys.filter((value) => {
      return value.toLowerCase().includes(searchWord.toLowerCase());
    });
    const newFilter = {};
    for (let k in newKeys) {
      newFilter[newKeys[k]] = makeData[k];
    }
    if (searchWord === "") {
      setFilteredData({ ...makeData });
    } else {
      setFilteredData(newFilter);
    }
  };

  React.useEffect(() => {
    if (selectedMake.length == 0) {
      reset();
    }
  }, [selectedMake]);

  const reset = () => {
    const c = { ...makeData };
    Object.keys(c).forEach((key) => (c[key] = false));
    setMakeData(c);
    setMakeCount(0);
    if (selectedMake.length > 0) setSelectedMake([]);
  };

  const handleClick = (e) => {
    const val = e.target.innerText;
    setMakeCount((oldCount) => oldCount + 1);
    setSelectedMake([...selectedMake, val]);
    setMakeData({ ...makeData, [val]: true });
  };

  const handleDeleteMake = (mk) => {
    setSelectedMake(selectedMake.filter((m) => m != mk));
    setMakeCount((oldCount) => oldCount - 1);
    setMakeData({ ...makeData, [mk]: false });
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          height: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <ArrowBackIcon
        onClick={toggleDrawer(false)}
        sx={{
          color: "primary.main",
          marginLeft: "20px",
          marginTop: "20px",
          marginBottom: "36px",
        }}
      />
      <Box sx={{ paddingX: "16px" }}>
        <Typography
          variant="h3"
          fontWeight="600"
          fontSize="22px"
          lineHeight="26px"
          color="text.primary"
        >
          Select make
        </Typography>
        <Box sx={{ height: "16px" }}></Box>
        <Fi
          value={wordEntered}
          handleChange={handleFilter}
          label="Search make"
          height="46.29px"
          endIcon={<SearchIcon sx={{ color: "#808080" }} />}
          focusedIcon={<SearchIcon sx={{ color: "primary.main" }} />}
          sx={{ width: "100%", marginX: "1px" }}
        />
        {selectedMake.length > 0 && <Box sx={{ height: "24px" }}></Box>}
        {selectedMake.length > 0 && (
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {selectedMake.map((m, i) => (
              <Btn
                key={i}
                variant="outlined"
                sx={{
                  backgroundColor: "#255CCE1A",
                  borderColor: "#255CCE",
                  padding: "8px",
                  height: "36px",
                  marginRight: "8px",
                }}
                size="lg"
                txColor="text.primary"
                typoVariant="body1"
                fontWeight="400"
                endIcon={
                  <CloseIcon
                    onClick={() => handleDeleteMake(m)}
                    sx={{
                      color: "text.primary",
                      width: "16px",
                      height: "16px",
                    }}
                  />
                }
              >
                {m}
              </Btn>
            ))}
          </Box>
        )}
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        ></Box>
        <Box sx={{ height: "24px" }}></Box>
        <Typography
          variant="caption"
          fontWeight="400"
          fontSize="12px"
          lineHeight="16px"
          color="#616161"
        >
          MAKES
        </Typography>
        <Box sx={{ height: "16px" }}></Box>
        {Object.keys(filteredData).map(
          (m) =>
            !makeData[m] && (
              <Typography
                variant="body1"
                fontWeight="400"
                fontSize="16px"
                lineHeight="24px"
                color="text.primary"
                sx={{ marginBottom: "16px" }}
                onClick={handleClick}
              >
                {m}
              </Typography>
            )
        )}
      </Box>
      {makeCount > 0 && (
        <Box
          sx={{
            width: "100%",
            height: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.8)",
            position: "absolute",
            bottom: "0",
          }}
        >
          <Btn
            variant="contained"
            bgColor="#F9D548"
            txColor="text.primary"
            size="lg"
            sx={{ height: "48px", width: "91.46%", boxShadow: "none" }}
            hoverBg="#F3C04F"
            onClick={toggleDrawer(false)}
          >
            Add {makeCount} Makes
          </Btn>
        </Box>
      )}
    </Drawer>
  );
}
